/** ========================================================================= *\
 * @module Draw Utilities
 * ========================================================================== */

/**
 * Draw a rectangle with a border.
 */
export function drawRectWithBorder(
  graphicObject,
  width,
  height,
  borderWidth,
  fillColor,
  borderColor
) {
  graphicObject.beginFill(borderColor);
  graphicObject.drawRect(0, 0, width, height);
  graphicObject.endFill();
  graphicObject.beginFill(fillColor);
  graphicObject.drawRect(borderWidth, borderWidth, width - borderWidth * 2, height - borderWidth * 2);
  graphicObject.endFill();
  return graphicObject;
}



// WEBPACK FOOTER //
// ./js/utils/draw.js